import React from 'react';

import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './NetworkSpeedChecker.module.scss';

const WarningText = () => {
  const { t } = useTranslation();

  return (
    <span data-bem="WarningText" className={CN.error}>
      <Icon variant="warning" width="xl" /> {t('staffAndBusiness.userNetwork.hardwareInformation.notMeetRequirements')}
    </span>
  );
};

export default WarningText;
